module.exports = {
  'NESTED': {
    svgName: 'icon-gp-128x128-01-nested.svg',
    remotePath: 'https://s3.us-west-2.amazonaws.com/assets.vrpatients.net/icons/icon-gp-128x128-1-nested.png'
  },
  'TREE': {
    svgName: 'icon-gp-128x128-02-tree.svg',
    remotePath: 'https://s3.us-west-2.amazonaws.com/assets.vrpatients.net/icons/icon-gp-128x128-2-tree.png'
  },
  'STAR': {
    svgName: 'icon-gp-128x128-03-star.svg',
    remotePath: 'https://s3.us-west-2.amazonaws.com/assets.vrpatients.net/icons/icon-gp-128x128-3-star.png'
  },
  'RIBBON': {
    svgName: 'icon-gp-128x128-04-ribbon.svg',
    remotePath: 'https://s3.us-west-2.amazonaws.com/assets.vrpatients.net/icons/icon-gp-128x128-4-ribbon.png'
  },
  'FLAG': {
    svgName: 'icon-gp-128x128-05-flag.svg',
    remotePath: 'https://s3.us-west-2.amazonaws.com/assets.vrpatients.net/icons/icon-gp-128x128-5-flag.png'
  },
  'PIN': {
    svgName: 'icon-gp-128x128-06-pin.svg',
    remotePath: 'https://s3.us-west-2.amazonaws.com/assets.vrpatients.net/icons/icon-gp-128x128-6-pin.png'
  },
  'EXCLAIM': {
    svgName: 'icon-gp-128x128-07-exclaim.svg',
    remotePath: 'https://s3.us-west-2.amazonaws.com/assets.vrpatients.net/icons/icon-gp-128x128-7-exclaim.png'
  },
  'EYE': {
    svgName: 'icon-gp-128x128-08-eye.svg',
    remotePath: 'https://s3.us-west-2.amazonaws.com/assets.vrpatients.net/icons/icon-gp-128x128-8-eye.png'
  },
  'BUTTON': {
    svgName: 'icon-gp-128x128-09-button.svg',
    remotePath: 'https://s3.us-west-2.amazonaws.com/assets.vrpatients.net/icons/icon-gp-128x128-9-button.png'
  }
};